// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Report Converter'"></sub-header>

  <form name="\$ctrl.form">
    <div class="alert" ng-if="\$ctrl.input.reportType === 'Comprehensive Credit and Equity Exposures (COCREE)'" >
    <div>
      <strong>When uploading multiple COCREE files, make sure: </strong><br><br>
      <strong>
      • Files follow the required sheet order (Header, Individuals, Companies, CompanyLinks, Installments, OtherCreditAccommodations, Investments, SubjectNegativeEvents, Footer). <br>
      • Each sheet must appear only once across all files. <br>
      • Empty sheets should contain headers only, with no extra rows. <br>
      </strong>
    </div>
  </div>
    <table class="misc-transaction__table table">
      <tbody>
      <tr>
        <td>1.</td>
        <td>Report type</td>
        <td>
          <select ng-model="\$ctrl.input.reportType"
                  ng-options="type.value as type.description for type in \$ctrl.reportTypes"
                  required></select>
        </td>
      </tr>
      <tr>
        <td>2.</td>
        <td>Report file format</td>
        <td>
          <select ng-model="\$ctrl.input.format"
                  ng-options="format.value as format.description for format in \$ctrl.formats"
                  required></select>
        </td>
      </tr>
      <tr>
        <td>3.</td>
        <td>Report file</td>
        <td>
          <file-upload
            ng-model="\$ctrl.conversionFile"
            ng-required="true"
            validate-uploaded
            max-files="9"
            show-file-name="true"
            show-remarks="false"
            enable-webcam="false"
            use-part-upload="true"
            validate="{pattern: '.xls,*.xlsx', size: { max: '50MB'}}">
          </file-upload>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        ng-click="\$ctrl.convertReport()"
        ng-disabled="\$ctrl.form.\$invalid">
        Convert Report
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/report/converter/report-convert.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;